export const GET_TRANSACTION_LIST = "transaction/all" ;
export const GET_WALLET_DETAILS = "transaction/wallet";
export const PAYMENT_REQUEST = "transaction/payment"